import '../styles/Contact.css';
import { useState } from 'react';

// ─── Web3Forms ───────────────────────────────────────────────────────────────
// FREE — no server needed. One-time setup:
//   1. Visit https://web3forms.com
//   2. Enter ckgroupofcompaniesltd@gmail.com → click "Create Access Key"
//   3. Paste the key below (check your inbox for the confirmation email too)
const ACCESS_KEY = 'f5efcacb-0341-4b2b-bb27-2eed5c7af56d';
// ─────────────────────────────────────────────────────────────────────────────

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: ''
  });
  const [status, setStatus] = useState('idle'); // idle | sending | success | error

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');

    try {
      const res = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          access_key: ACCESS_KEY,
          subject: `Enquiry from ${formData.name}${formData.company ? ` (${formData.company})` : ''}`,
          from_name: formData.name,
          replyto: formData.email,
          name: formData.name,
          email: formData.email,
          company: formData.company || '—',
          message: formData.message,
        }),
      });

      const data = await res.json();

      if (data.success) {
        setStatus('success');
        setFormData({ name: '', email: '', company: '', message: '' });
      } else {
        console.error('Web3Forms error:', data);
        setStatus('error');
      }
    } catch (err) {
      console.error('Network error:', err);
      setStatus('error');
    }
  };

  return (
    <div className="contact">
      {/* Header */}
      <section className="contact-header">
        <div className="contact-header-overlay"></div>
        <div className="contact-header-content">
          <h1>Get in Touch</h1>
          <p>Let's discuss how we can help transform your organization</p>
        </div>
      </section>

      {/* Contact Content */}
      <section className="contact-content">
        <div className="contact-container">

          {/* Form */}
          <div className="contact-form-section">
            <h2>Send us a Message</h2>

            {status === 'success' ? (
              <div className="form-success">
                <div className="form-success-icon">✓</div>
                <h3>Message sent!</h3>
                <p>Thank you — your message has landed directly in our inbox. We'll be in touch shortly.</p>
                <button
                  className="submit-btn"
                  style={{ marginTop: '16px' }}
                  onClick={() => setStatus('idle')}
                >
                  Send another message
                </button>
              </div>
            ) : (
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">Full Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Your name"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email Address</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="your@email.com"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="company">Company</label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    value={formData.company}
                    onChange={handleChange}
                    placeholder="Your company"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">Message</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    placeholder="Tell us about your challenge..."
                    rows="6"
                  ></textarea>
                </div>

                {status === 'error' && (
                  <p className="form-error">
                    Something went wrong. Please email us directly at{' '}
                    <a href="mailto:ckgroupofcompaniesltd@gmail.com">
                      ckgroupofcompaniesltd@gmail.com
                    </a>.
                  </p>
                )}

                <button
                  type="submit"
                  className="submit-btn"
                  disabled={status === 'sending'}
                >
                  {status === 'sending' ? 'Sending…' : 'Send Message'}
                </button>
              </form>
            )}
          </div>

          {/* Contact Info */}
          <div className="contact-info-section">
            <div className="contact-office-image">
              <img
                src="https://images.unsplash.com/photo-1497366216548-37526070297c?w=600&h=350&fit=crop"
                alt="CK Innovation office"
                className="office-img"
              />
            </div>
            <h2>Contact Information</h2>
            <div className="info-item">
              <h4>Address</h4>
              <p>United Kingdom</p>
              <p>
                <a href="mailto:ckgroupofcompaniesltd@gmail.com">
                  ckgroupofcompaniesltd@gmail.com
                </a>
              </p>
              <p>
                <a href="tel:+447427083110">+44 7427 083110</a>
              </p>
            </div>
          </div>

        </div>
      </section>

      {/* Map */}
      <section className="contact-map-section">
        <img
          src="https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=1400&h=400&fit=crop"
          alt="London skyline"
          className="contact-map-img"
        />
        <div className="contact-map-overlay">
          <p>Based in London, serving clients across the UK &amp; Europe</p>
        </div>
      </section>
    </div>
  );
}

export default Contact;
